import React from 'react';
import { Location, createLocation } from 'history';
import { Link } from 'react-router-dom';
import { isLessonsChartRoute } from 'utils/routes';
import styles from './styles.module.scss';

interface IViewSwitcherProps {
  location: Location;
  listViewRoute: string;
  chartViewRoute: string;
}

const ViewSwitcher = ({
  location,
  listViewRoute,
  chartViewRoute,
}: IViewSwitcherProps) => {
  const currentRouteIsChart = isLessonsChartRoute(location);
  const nextRoute = currentRouteIsChart ? listViewRoute : chartViewRoute;
  const style = currentRouteIsChart ? 'right' : 'left';

  return (
    <div className={styles.container}>
      <Link to={listViewRoute} className={styles.link}>
        List View
      </Link>
      <Link data-testid="switcher" to={nextRoute} className={styles.switcher}>
        <span className={styles[style]} />
      </Link>
      <Link to={chartViewRoute} className={styles.link}>
        Chart View
      </Link>
    </div>
  );
};

export default ViewSwitcher;
